'use client'

import { useTranslations } from 'next-intl'

import { contentDesignFormConfig } from '@/content-from-sections/client'

import { ContentForm } from '../../ContentForm'
import {
	facebookFormConfig,
	ImagesField,
	qrNameFormConfig,
	TQrContentFormSection,
	welcomeScreenFormConfig,
} from '../../contentFormSections'
import { QR_TYPE, TContentFormProps } from '../../generatorTypes'

export const FacebookContentForm = (props: TContentFormProps) => {
	const t = useTranslations()

	const config = {
		formSectionList: [
			contentDesignFormConfig(t, ImagesField),
			facebookFormConfig(t),
			welcomeScreenFormConfig(t),
			qrNameFormConfig(t),
		] satisfies TQrContentFormSection[],
	}

	return <ContentForm qrType={QR_TYPE.Facebook} config={config} {...props} />
}
